import React from 'react';
import { Wallet, Shield, Clock, Users, Building2, ChevronRight } from 'lucide-react';
import Breadcrumbs from '../Navigation/Breadcrumbs';
import RequestForm from './RequestForm';

function PaymentPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section with Gradient Background */}
      <section className="pt-32 pb-40 px-6 bg-gradient-to-b from-[#1B3BA0] to-[#0F2875] relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1553729459-efe14ef6055d?auto=format&fit=crop&q=80')] bg-cover bg-center opacity-10"></div>
          <div className="absolute inset-0 bg-[#1B3BA0]/50 mix-blend-multiply"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#1B3BA0]/20"></div>
        </div>
        <div className="max-w-[980px] mx-auto relative">
          <div className="mb-12">
            <Breadcrumbs />
          </div>
          <div className="max-w-[780px]">
            <h1 className="text-5xl md:text-7xl font-bold mb-8 tracking-tight">
              <span className="text-white block mb-2">Оплата поставщикам</span>
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-white to-[#99BBFF]">
                в Китае
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-white/80 leading-relaxed">
              С 2013 года помогаем бизнесу эффективно и безопасно проводить оплату китайским поставщикам
            </p>
          </div>
        </div>
      </section>

      {/* Payment Methods Section */}
      <section className="py-24 px-6 bg-white relative z-10 -mt-20">
        <div className="max-w-[980px] mx-auto">
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-2xl border border-gray-100">
            <h2 className="text-3xl font-bold text-[#1B3BA0] mb-6">
              Для малого и среднего бизнеса
            </h2>
            <p className="text-lg text-gray-600 mb-12 leading-relaxed">
              Предлагаем удобные и безопасные способы оплаты, адаптированные под потребности вашего бизнеса.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-[#1B3BA0]/5 rounded-2xl p-8 hover:bg-[#1B3BA0]/10 transition-all duration-300 transform hover:-translate-y-1">
                <Wallet className="w-12 h-12 text-[#1B3BA0] mb-6" />
                <h3 className="text-xl font-bold text-[#1B3BA0] mb-4">
                  Удобные способы оплаты
                </h3>
                <ul className="space-y-4 text-gray-600">
                  <li className="flex items-center">
                    <ChevronRight className="w-5 h-5 text-[#1B3BA0] mr-2" />
                    Перевод на российскую банковскую карту
                  </li>
                  <li className="flex items-center">
                    <ChevronRight className="w-5 h-5 text-[#1B3BA0] mr-2" />
                    Оплата в USDT
                  </li>
                </ul>
              </div>
              <div className="bg-[#1B3BA0]/5 rounded-2xl p-8 hover:bg-[#1B3BA0]/10 transition-all duration-300 transform hover:-translate-y-1">
                <Shield className="w-12 h-12 text-[#1B3BA0] mb-6" />
                <h3 className="text-xl font-bold text-[#1B3BA0] mb-4">
                  Безопасный перевод
                </h3>
                <p className="text-gray-600">
                  Мы самостоятельно осуществим перевод в Китай и оплату поставщикам от вашего имени. Это быстро, удобно и безопасно. Все процессы отлажены годами практики.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Enterprise Section */}
      <section className="py-32 px-6 bg-gradient-to-b from-white to-[#1B3BA0]/5">
        <div className="max-w-[980px] mx-auto">
          <h2 className="text-4xl font-bold text-center text-[#1B3BA0] mb-16">
            Для крупных компаний
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
              <Building2 className="w-12 h-12 text-[#1B3BA0] mb-6" />
              <h3 className="text-xl font-bold text-[#1B3BA0] mb-4">
                Брокерские услуги
              </h3>
              <p className="text-gray-600 mb-4">
                Возможность перевода средств поставщику через нашего проверенного брокера.
              </p>
              <p className="text-[#1B3BA0] font-bold">
                Комиссия: от 1% до 2% в зависимости от суммы
              </p>
            </div>
            <div className="bg-white rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
              <Users className="w-12 h-12 text-[#1B3BA0] mb-6" />
              <h3 className="text-xl font-bold text-[#1B3BA0] mb-4">
                Консультации
              </h3>
              <p className="text-gray-600">
                Консультации по прямым международным переводам и помощь в подборе подходящего способа оплаты для вашего бизнеса.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section className="py-32 px-6 bg-[#1B3BA0]">
        <div className="max-w-[780px] mx-auto text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Получить консультацию
          </h2>
          <p className="text-xl text-white/80 mb-12 max-w-2xl mx-auto">
            Оставьте заявку, и мы поможем выбрать оптимальный способ оплаты для вашего бизнеса
          </p>
          <RequestForm source="Оплата поставщикам" />
        </div>
      </section>
    </div>
  );
}

export default PaymentPage;